<template>
  <b-modal size="lg" :title="title" v-model="show" hide-footer>
    <div v-html="content"></div>
  </b-modal>
</template>
<script>
export default {
  props: ['title', 'content', 'openInitial'],
  data() {
    return {
      show: !!(this.openInitial || this.openInitial === "true")
    }
  }
}
</script>